function escapeHtml(input: string) {
  return input.replace(/[&<>'"]/g, (char) => {
    const entityMap: { [key: string]: string } = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      "'": "&#39;",
      '"': "&quot;",
    };
    return entityMap[char] || "";
  });
}

function sanitizeHTML(input: string, additionalAllowedTags: string[] = []) {
  const defaultAllowedTags = ["b", "u"];
  const allowedTags = [...defaultAllowedTags, ...additionalAllowedTags];
  const stack: string[] = [];
  return escapeHtml(input).replace(
    /&lt;(\/?)([\w]+)(.*?)&gt;/g,
    (_, closing: string, tag: string, attr: string) => {
      tag = tag.toLowerCase();

      if (allowedTags.includes(tag)) {
        if (!closing) {
          stack.push(tag);

          // IMG has attributes src, width, height
          if (tag === "img") {
            const srcSearch = /src=&quot;(.*?)&quot;/.exec(attr);
            const widthSearch = /width=&quot;(.*?)&quot;/.exec(attr);
            const heightSearch = /height=&quot;(.*?)&quot;/.exec(attr);
            const src = srcSearch ? srcSearch[1] : "";
            const width = widthSearch ? widthSearch[1] : "";
            const height = heightSearch ? heightSearch[1] : "";
            //img has no closing tag
            stack.pop();
            return `<${tag} src="${src}" width="${width}" height="${height}" />`;
          }
          // A has attribute href
          if (tag === "a") {
            const hrefSearch = /href=&quot;(.*?)&quot;/.exec(attr);
            const href = hrefSearch ? hrefSearch[1] : "";
            return `<${tag} href="${href}" target="_blank">`;
          }

          return `<${tag}>`;
        } else {
          if (stack.length && stack[stack.length - 1] === tag) {
            stack.pop();
            return `</${tag}>`;
          }
        }
      }
      return "";
    },
  );
}

export default sanitizeHTML;
